import { styled } from "@mui/material/styles";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

const PREFIX = "SlackIcon";

const classes = {
	root: `${PREFIX}root`,
};

const StyledSvgIcon = styled(SvgIcon)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		"& > *": {
			fill: "currentColor",
		},
	},
}));

interface Props extends SvgIconProps {
	mono: boolean;
}

export const SlackIcon: FunctionComponent<Props> = ({ mono, ...props }) => {
	return (
		<StyledSvgIcon
			className={mono ? classes.root : null}
			viewBox="0 0 16 16"
			{...props}
		>
			<path d="M4.39238 9.64175C4.39238 10.3613 3.80462 10.949 3.08511 10.949C2.3656 10.949 1.77783 10.3613 1.77783 9.64175C1.77783 8.92224 2.3656 8.33447 3.08511 8.33447H4.39238V9.64175Z" fill="#E01E5A" />
			<path d="M5.05103 9.64175C5.05103 8.92224 5.63879 8.33447 6.3583 8.33447C7.07781 8.33447 7.66558 8.92224 7.66558 9.64175V12.915C7.66558 13.6345 7.07781 14.2223 6.3583 14.2223C5.63879 14.2223 5.05103 13.6345 5.05103 12.915V9.64175Z" fill="#E01E5A" />
			<path d="M6.3583 4.39239C5.63879 4.39239 5.05103 3.80462 5.05103 3.08511C5.05103 2.3656 5.63879 1.77783 6.3583 1.77783C7.07781 1.77783 7.66558 2.3656 7.66558 3.08511V4.39239H6.3583Z" fill="#36C5F0" />
			<path d="M6.35837 5.05127C7.07788 5.05127 7.66565 5.63904 7.66565 6.35855C7.66565 7.07806 7.07788 7.66583 6.35837 7.66583H3.08511C2.3656 7.66583 1.77783 7.07806 1.77783 6.35855C1.77783 5.63904 2.3656 5.05127 3.08511 5.05127H6.35837Z" fill="#36C5F0" />
			<path d="M11.6074 6.35855C11.6074 5.63904 12.1952 5.05127 12.9147 5.05127C13.6342 5.05127 14.222 5.63904 14.222 6.35855C14.222 7.07806 13.6342 7.66583 12.9147 7.66583H11.6074V6.35855Z" fill="#2EB67D" />
			<path d="M10.9485 6.35837C10.9485 7.07788 10.3608 7.66565 9.64126 7.66565C8.92175 7.66565 8.33398 7.07788 8.33398 6.35837V3.08511C8.33398 2.3656 8.92175 1.77783 9.64126 1.77783C10.3608 1.77783 10.9485 2.3656 10.9485 3.08511V6.35837Z" fill="#2EB67D" />
			<path d="M9.6415 11.6079C10.361 11.6079 10.9488 12.1957 10.9488 12.9152C10.9488 13.6347 10.361 14.2225 9.6415 14.2225C8.922 14.2225 8.33423 13.6347 8.33423 12.9152V11.6079H9.6415Z" fill="#ECB22E" />
			<path d="M9.64175 10.949C8.92224 10.949 8.33447 10.3613 8.33447 9.64175C8.33447 8.92224 8.92224 8.33447 9.64175 8.33447H12.915C13.6345 8.33447 14.2223 8.92224 14.2223 9.64175C14.2223 10.3613 13.6345 10.949 12.915 10.949H9.64175Z" fill="#ECB22E" />
		</StyledSvgIcon>
	);
};

export default SlackIcon;
